import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { AddAdsLayer } from "../components/ads/AddAdsLayer";

export const AddAdsPage = () => {
  return (
    <MasterLayout>
      <AddAdsLayer />
    </MasterLayout>
  );
};
